import { HttpErrorResponse } from "@angular/common/http";
import { User } from "@domains/user";
import { createAction, props } from "@ngrx/store";
import { StoreActions, StoreActionStatuses } from "@utility/state";

const ACTION_SUBJECT = "User";
const ACTION_TITLE = `[${ACTION_SUBJECT}]`;

export const LOAD_USER = `${ACTION_TITLE} ${StoreActions.LOAD} ${ACTION_SUBJECT}`;
const LOAD_USER_SUCCESS = `${LOAD_USER} ${StoreActionStatuses.SUCCESS}`;
const LOAD_USER_FAILURE = `${LOAD_USER} ${StoreActionStatuses.FAILURE}`;

export const loadUser = createAction(LOAD_USER);
export const loadUserSuccess = createAction(LOAD_USER_SUCCESS, props<{ user: User }>());
export const loadUserFailure = createAction(LOAD_USER_FAILURE, props<{ error: HttpErrorResponse }>());

export const SAVE_USER = `${ACTION_TITLE} ${StoreActions.UPDATE} ${ACTION_SUBJECT}`;
const SAVE_USER_SUCCESS = `${SAVE_USER} ${StoreActionStatuses.SUCCESS}`;
const SAVE_USER_FAILURE = `${SAVE_USER} ${StoreActionStatuses.FAILURE}`;

export const saveUser = createAction(SAVE_USER);
export const saveUserSuccess = createAction(SAVE_USER_SUCCESS, props<{ firstName: string; lastName: string }>());
export const saveUserFailure = createAction(SAVE_USER_FAILURE);
